// import lib(s)
import React, { useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import styles from "./AllLeadView.module.css"
import { useTheme } from "@emotion/react"

import { useNavigate, useParams } from "react-router-dom"

import { selectLead } from '../AnnotatorSlice'

import FullWidthECGPreview from "../../../components/FullWidthECGPreview"
import applyInversion from "../../../utils/applyInversion"

const AllLeadView = (props) => {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const urlParams = useParams()
	const theme = useTheme()

	// Annotator Data
	const AnnotatorData = useSelector((state) => state.Annotator)
	const ecg = AnnotatorData.filtered
	const totalLeads = AnnotatorData.leadCount
	const inverted = AnnotatorData.settings.inverted
	const samples = useMemo(
		() => (inverted ? applyInversion(ecg.samples) : ecg.samples),
		[inverted, ecg.samples],
	)


	const HeightPerStrip = 200
	const AllLeadWidth = (ecg.duration*100) * AnnotatorData.settings.scale
	const AllLeadHeight = (totalLeads*HeightPerStrip + 1) * AnnotatorData.settings.scale
	return (
			<div style={{height: `${AllLeadHeight}px`, width: `${AllLeadWidth}px`, position: "relative" }} className={styles.RightColumn}>
				{Object.keys(samples).map((lead) => (
					<FullWidthECGPreview
						key={lead}
						ecgTitle = {lead}
						enableBeats = {true}
						scale = {AnnotatorData.settings.scale}
						sample = {samples[lead]}
						beats = {AnnotatorData.annotations.beats}
						beatLabel = {AnnotatorData.annotations.labels.beats}
						seconds = {ecg.duration || 30}
						heightFactor = {2}
						mvSwing = {ecg.gain*2.5}
						onClick={()=>{
							dispatch(selectLead(lead))
							props.changeTab(2)
						}}
						style={{cursor: "pointer"}}
						renderTimeScaleFactor = {2}
						frequency={ecg.frequency}
					/>
				))}
			</div>
	)
}


export default AllLeadView
